export const GUI_FORM_STATE_EVENT = {
  FORM_SUCCESSFULLY_SAVED: "FORM_SUCCESSFULLY_SAVED",
  FORM_FAILED_TO_SAVE: "FORM_FAILED_TO_SAVE",
  EXIT_FORM_UPDATE: "EXIT_FORM_UPDATE"
}
